// extracted by mini-css-extract-plugin
export var toolTipContainer = "bj_dx";
export var toolTipLabel = "bj_dy";